import Tooltip, { type TooltipProps } from '@mui/material/Tooltip';
import { styled as styledEmotion } from '@mui/material/styles';

type InfoTooltipProps = {
  className?: string;
} & TooltipProps;

export const InfoTooltip = styledEmotion(({ className, ...props }: InfoTooltipProps) => (
  <Tooltip {...props} classes={{ popper: className }} />
))`
  & .MuiTooltip-tooltip {
    padding: 12px;
    border-radius: 5px;
    font-size: 12px;
    line-height: 16px;
  }
`;
